<div class="main-container" style="margin-bottom: 60px">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>General Information</mat-card-title>
      <mat-card-content>
        @if (serverError) {
          <div class="alert alert-danger alert-dismissible" role="alert">Error occurred</div>
        }
        <app-mat-text-input
          [formControl]="getFormControl('account')"
          [readonly]="true"
          label="Account"
          name="account">
        </app-mat-text-input>
        <app-mat-text-input
          [formControl]="getFormControl('display')"
          label="Name"
          name="display"
          [readonly]="true">
        </app-mat-text-input>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-title>Work Hours</mat-card-title>
      <mat-card-content>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          <app-mat-time-picker [formControl]="getFormControl('workHoursStart')"
                               format="12"
                               [showSeconds]="false"
                               name="workHoursStart"
                               label="Start Time"
                               [submitted]="submitted">
          </app-mat-time-picker>
          <app-mat-time-picker [formControl]="getFormControl('workHoursEnd')"
                               format="12"
                               [showSeconds]="false"
                               name="workHoursEnd"
                               label="End Time"
                               [submitted]="submitted">
          </app-mat-time-picker>
          <!--<app-mat-time-input [formControl]="getFormControl('workHoursStart')"
                              name="workHoursEnd"
                              label="End Time"
                              [submitted]="submitted">
          </app-mat-time-input>
          <app-mat-time-input [formControl]="getFormControl('workHoursEnd')"
                              name="workHoursEnd"
                              label="End Time"
                              [submitted]="submitted">
          </app-mat-time-input>-->
        </div>

      </mat-card-content>
    </mat-card>
  </form>
</div>
<div class="edit-action-bar">
  @if (hasEditAccess) {
    <button
      mat-raised-button
      type="button"
      color="primary"
      matTooltip="Save changes"
      (click)="onSubmit()"
      [disabled]="submitted"
      [promiseBtn]="buttonSubmitPromise">
      Save
    </button>
  }
</div>
